interface SwitchProps {
  checked: boolean;
  onChange: () => void;
  disabled?: boolean;
}

export const Switch = ({ checked, onChange, disabled }: SwitchProps) => {
  return (
    <label className="relative inline-flex items-center cursor-pointer">
      <input
        type="checkbox"
        className="sr-only peer"
        checked={checked}
        onChange={onChange}
        disabled={disabled}
      />
      <div className={`
        w-11 h-6 bg-gray-200 
        peer-focus:outline-none peer-focus:ring-4 
        peer-focus:ring-primary/20
        rounded-full peer 
        peer-checked:after:translate-x-full 
        peer-checked:after:border-white 
        after:content-[''] 
        after:absolute 
        after:top-[2px] 
        after:left-[2px] 
        after:bg-white 
        after:border-gray-300 
        after:border 
        after:rounded-full 
        after:h-5 
        after:w-5 
        after:transition-all
        peer-checked:bg-primary
        ${disabled ? 'opacity-50 cursor-not-allowed' : ''}
      `}></div>
    </label>
  );
}; 